import { Component, Input, OnInit } from '@angular/core';
import { AddAzureBlobstorageModal } from '../components/addAzureBlobstorage/addAzureBlobstorage.modal';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DisableAzureBlobstorageModal } from '../components/disableAzureBlobstorage/disableAzureBlobstorage.modal';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '../settings.service';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { Subscription } from 'rxjs';
import { BreadCrumbOptions, SettingsBreadCrumbService } from '../settings-breadcrumb.service';
import { IdsForSettingsService } from '../ids-for-settings.service';
import { IdentityWhitelabelApiClient } from 'src/app/services/api-clients/identity-whitelabel.api-client';
import { IdentitySystemApiClient } from 'src/app/services/api-clients/identity-system.api-client';

@Component({
  templateUrl: './storage.page.html'
})
export class StoragePage implements OnInit {

  storageAvailable: boolean = false;
  premiumRequired: boolean = false;
  @Input('blobstorageConnectionstringActive') blobstorageConnectionstringActive: boolean = false;
  @Input('blobstorageConnectionstring') blobstorageConnectionstring!: string;
  translations = <any>{};

  constructor(
    protected settingsService: SettingsService,
    protected modalService: NgbModal,
    protected idsForSettingsService: IdsForSettingsService,
    protected translateService: TranslateService,
    protected settingsBreadCrumbService: SettingsBreadCrumbService) {

  }

  async ngOnInit(): Promise<void> {
    this.getTranslations();
    this.translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
  }


  getTranslations() {
    this.translateService.get([
      'Toasts.Saved',
      'Toasts.ChangesSaved'
    ]).subscribe(translation => {
      this.translations.toastSaved = translation['Toasts.Saved'];
      this.translations.toastChangedSaved = translation['Toasts.ChangesSaved'];
    });
  }

  toggleUsePrivateStorage(event: any) {
    let checkbox = document.getElementById('privateStorage') as HTMLInputElement | null;
    if (checkbox == null) return;
    if (checkbox.checked) this.openBlobStorage();
    else this.disableBlobStorage();
  }

  openBlobStorage() {
    if (this.modalService.hasOpenModals()) return;
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static'
    };

    const modalRef = this.modalService.open(AddAzureBlobstorageModal, ngbModalOptions);
    modalRef.componentInstance.close.subscribe({
      next: () => {
        let checkbox = document.getElementById('privateStorage') as HTMLInputElement | null;
        if (checkbox != null) checkbox.checked = false;
        modalRef.close();
      }
    });
    modalRef.componentInstance.updatedConnectionstring.subscribe({
      next: (blobstorageConnectionstring: string) => {
        this.blobstorageConnectionstring = blobstorageConnectionstring;
        this.blobstorageConnectionstringActive = true;
        this.updateWhitelabelAzureBlobstorage();
        modalRef.close();
      }
    });
  }

  editBlobStorage() {
    if (this.modalService.hasOpenModals()) return;
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static'
    };

    const modalRef = this.modalService.open(AddAzureBlobstorageModal, ngbModalOptions);
    modalRef.componentInstance.blobstorageConnectionstring = this.blobstorageConnectionstring;
    modalRef.componentInstance.blobstorageConnectionstringActive = this.blobstorageConnectionstringActive;
    modalRef.componentInstance.close.subscribe({
      next: () => {
        modalRef.close();
      }
    });
    modalRef.componentInstance.updatedConnectionstring.subscribe({
      next: (blobstorageConnectionstring: string) => {
        this.blobstorageConnectionstring = blobstorageConnectionstring;
        this.blobstorageConnectionstringActive = true;
        this.updateWhitelabelAzureBlobstorage();
        modalRef.close();
      }
    });
  }

  disableBlobStorage() {
    if (this.modalService.hasOpenModals()) return;
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static'
    };

    const modalRef = this.modalService.open(DisableAzureBlobstorageModal, ngbModalOptions);
    modalRef.componentInstance.close.subscribe({
      next: () => {
        let checkbox = document.getElementById('privateStorage') as HTMLInputElement | null;
        if (checkbox != null) checkbox.checked = true;
        modalRef.close();
      }
    });
    modalRef.componentInstance.disable.subscribe({
      next: () => {
        this.blobstorageConnectionstringActive = false;
        this.blobstorageConnectionstring = "";
        this.updateWhitelabelAzureBlobstorage();
        modalRef.close();
      }
    });
  }
  updateWhitelabelAzureBlobstorage(){
    //empty function
  }
}

@Component({
  templateUrl: './storage.page.html'
})
export class OrganisationStoragePage extends StoragePage {

  selectedOrganisationId: string = "";
  organisationIdSubscription: Subscription;
  override premiumRequired: boolean = true;

  constructor(private identityOrganisationApiClient: IdentityOrganisationApiClient,
    protected override settingsService: SettingsService,
    protected override modalService: NgbModal,
    protected override idsForSettingsService: IdsForSettingsService,
    protected override translateService: TranslateService,
    protected override settingsBreadCrumbService: SettingsBreadCrumbService) {
    
    super(settingsService, modalService, idsForSettingsService, translateService, settingsBreadCrumbService);
    this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
      // setup specialised breadcrumb with organisationId
      this.settingsBreadCrumbService.SetOrganisationCrumbs(BreadCrumbOptions.Organisation_Storage(this.selectedOrganisationId));

      this.selectedOrganisationId = organisationId;
      if (organisationId) {
        this.getAzureblobstorage(this.selectedOrganisationId);

        this.identityOrganisationApiClient.getOrganisation(organisationId).subscribe(organisationData => {
          this.storageAvailable = organisationData.organisation.customStorageEnabled;
        });
      }
    });

  }
  ngOnDestroy(): void {
    this.organisationIdSubscription.unsubscribe();
  }

  async getAzureblobstorage(organisationGuid: string) {
    (await this.identityOrganisationApiClient.getAzureblobstorage(organisationGuid)).subscribe({
      next: (data: any) => {
        this.blobstorageConnectionstring = data.storageAccount;
        if (this.blobstorageConnectionstring !== '' && this.blobstorageConnectionstring !== null && this.blobstorageConnectionstring !== undefined) this.blobstorageConnectionstringActive = true;
      }
    });
  }

  override getTranslations() {
    this.translateService.get([
      'Toasts.Saved',
      'Toasts.ChangesSaved'
    ]).subscribe(translation => {
      this.translations.toastSaved = translation['Toasts.Saved'];
      this.translations.toastChangedSaved = translation['Toasts.ChangesSaved'];
    });
  }

  override updateWhitelabelAzureBlobstorage(){
    this.settingsService.updateOrganisationAzureBlobstorage(this.blobstorageConnectionstring, this.selectedOrganisationId);
  }

}

@Component({
  templateUrl: './storage.page.html'
})
export class WhiteLabelStoragePage extends StoragePage {

  selectedWhiteLabelId: string = "";
  whiteLabelIdSubscription: Subscription;
  
  constructor(private identityWhitelabelApiClient: IdentityWhitelabelApiClient,
    protected override settingsService: SettingsService,
    protected override modalService: NgbModal,
    protected override idsForSettingsService: IdsForSettingsService,
    protected override translateService: TranslateService,
    protected override settingsBreadCrumbService: SettingsBreadCrumbService) {
    
    super(settingsService, modalService, idsForSettingsService, translateService, settingsBreadCrumbService);


    this.whiteLabelIdSubscription = this.idsForSettingsService.selectedWhiteLabelId$.subscribe(whiteLabelId => {
      this.selectedWhiteLabelId = whiteLabelId;
      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetWhiteLabelCrumbs(BreadCrumbOptions.Whitelabel_Storage(this.selectedWhiteLabelId));
      if (whiteLabelId) {
        this.getAzureblobstorage(this.selectedWhiteLabelId);

        this.identityWhitelabelApiClient.getWhitelabel(whiteLabelId).subscribe(whiteLabelData => {
          this.storageAvailable = whiteLabelData.whiteLabel.customStorageEnabled;
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.whiteLabelIdSubscription.unsubscribe();
  }

  async getAzureblobstorage(whiteLabelId: string) {
    (await this.identityWhitelabelApiClient.getAzureblobstorage(whiteLabelId)).subscribe({
      next: (data: any) => {
        this.blobstorageConnectionstring = data.storageAccount;
        if (this.blobstorageConnectionstring !== '' && this.blobstorageConnectionstring !== null && this.blobstorageConnectionstring !== undefined) this.blobstorageConnectionstringActive = true;
      }
    });
  }

  override updateWhitelabelAzureBlobstorage(){
    this.settingsService.updateOrganisationAzureBlobstorage(this.blobstorageConnectionstring, this.selectedWhiteLabelId);
  }

}

@Component({
  templateUrl: './storage.page.html'
})
export class SystemStoragePage extends StoragePage {

  selectedSystemId: string = "";
  systemIdSubscription: Subscription;
  
  constructor(private identitySystemApiClient: IdentitySystemApiClient,
    protected override settingsService: SettingsService,
    protected override modalService: NgbModal,
    protected override idsForSettingsService: IdsForSettingsService,
    protected override translateService: TranslateService,
    protected override settingsBreadCrumbService: SettingsBreadCrumbService) {
    
    super(settingsService, modalService, idsForSettingsService, translateService, settingsBreadCrumbService);


    this.systemIdSubscription = this.idsForSettingsService.selectedSystemId$.subscribe(systemId => {
      this.selectedSystemId = systemId;
      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetSystemCrumbs(BreadCrumbOptions.System_Storage);
      if (systemId) {
        this.getAzureblobstorage(this.selectedSystemId);

        this.identitySystemApiClient.getSystem(systemId).subscribe(systemData => {
          this.storageAvailable = systemData.system.customStorageEnabled;
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.systemIdSubscription.unsubscribe();
  }

  async getAzureblobstorage(systemId: string) {
    (await this.identitySystemApiClient.getAzureblobstorage(systemId)).subscribe({
      next: (data: any) => {
        this.blobstorageConnectionstring = data.storageAccount;
        if (this.blobstorageConnectionstring !== '' && this.blobstorageConnectionstring !== null && this.blobstorageConnectionstring !== undefined) this.blobstorageConnectionstringActive = true;
      }
    });
  }

  override updateWhitelabelAzureBlobstorage(){
    this.settingsService.updateSystemAzureBlobstorage(this.blobstorageConnectionstring, this.selectedSystemId);
  }

}